import { LinearProgress } from '@mui/material';
import React from 'react';
import { Modal } from '../../../components';
import { useSelector } from '../../../stores';

export const SalesExportModal: React.FC = () => {
  const { salesExportPercentage, salesExportModalIsOpen } = useSelector(
    (state) => state.salesListReducer,
  );

  return (
    <Modal
      open={salesExportModalIsOpen}
      onClose={() => {}}
      title='Preparando exportação'
      noCloseButton
    >
      <LinearProgress
        variant='determinate'
        value={salesExportPercentage}
        sx={{ height: '20px', borderRadius: '40px' }}
      />
    </Modal>
  );
};
